import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "Built on gratitude.",
    body: "Photo Booth Memories was founded by George & Lucy — two typical Americans chasing a dream, thankful to God for the opportunity to build a family business that celebrates yours.",
    img: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/e641f258-6793-4829-80c4-dfa01792c70b_2x",
  },
  {
    n: "02",
    title: "Loud on delight.",
    body: "Mirror photo booth, red-carpet moment, unlimited boomerangs & GIFs, props styled for your event. It's a party inside a party — and your guests won't stop talking about it.",
    img: "https://bc-user-uploads.brandcrowd.com/public/media-Production/4e66984e-ccb1-4743-b5bf-abeb6dbac48e/868d44ab-608a-48ae-82df-212f65209d91_2x",
  },
  {
    n: "03",
    title: "Prints in your hand.",
    body: "Unlimited on-site prints (2x6 strips or 4x6), instant digital sharing on the spot, custom templates designed for your event — and higher tiers include a magazine keepsake and full digital gallery on USB.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/kou4nlhi_IMG_4629.jpeg",
  },
  {
    n: "04",
    title: "The night, on repeat.",
    body: "Every event ships with a party keepsake — a signature composite print your guests can hold onto. From open-bar toasts to the last balloon drop, we bottle the whole night into one frame.",
    img: "https://customer-assets-0z36b82j.emergentagent.net/job_memory-booth-8/artifacts/dfdtz3u6_IMG_4568.jpeg",
  },
];

const reveal = {
  initial: { y: 40, opacity: 0 },
  whileInView: { y: 0, opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] },
};

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-[#FDFBF7] py-24 md:py-40" data-testid="manifesto-section">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <motion.div {...reveal} className="flex items-end justify-between mb-16 md:mb-24">
          <div>
            <div className="overline text-[#0A0A0A]/60 mb-4">The Manifesto</div>
            <h2 className="font-serif font-light text-5xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight text-[#0A0A0A] max-w-3xl">
              Four chapters we <em className="text-[#FF5722]">believe</em> in.
            </h2>
          </div>
          <div className="hidden md:block text-right">
            <div className="overline text-[#0A0A0A]/60">IV</div>
          </div>
        </motion.div>

        <div className="space-y-24 md:space-y-40">
          {chapters.map((c, i) => (
            <motion.div
              key={c.n}
              {...reveal}
              className={`grid grid-cols-1 md:grid-cols-12 items-center gap-8 md:gap-12 ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
            >
              <div className="md:col-span-5 md:[direction:ltr]">
                <div className="relative">
                  <img
                    src={c.img}
                    alt=""
                    loading="lazy"
                    className="w-full h-auto max-h-[80vh] object-contain shadow-xl"
                  />
                </div>
              </div>
              <div className="md:col-span-6 md:col-start-7 md:[direction:ltr]">
                <div className="flex items-baseline gap-6">
                  <span className="font-serif italic text-[#FF5722] text-6xl md:text-7xl leading-none">{c.n}</span>
                  <span className="h-px flex-1 bg-[#0A0A0A]/20" />
                </div>
                <h3 className="font-serif text-4xl md:text-6xl mt-6 text-[#0A0A0A] leading-tight">{c.title}</h3>
                <p className="mt-6 text-base md:text-lg text-[#0A0A0A]/75 max-w-md leading-relaxed">{c.body}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
